module.exports = __webpack_public_path__ + "static/img/family.8ad8638b.png";